/* TFC Klaviyo: "Added to Cart"-tracking + winactie-inschrijving (popup en footer).
   Geen ingebouwde teksten: alle meldingen komen uit data-attributen die Liquid met locale-sleutels vult. */
(function () {
  'use strict';
  if (window.tfcWinactie) return;
  window.tfcWinactie = true;

  var cfg = {};
  try { cfg = JSON.parse((document.getElementById('tfc-klaviyo-config') || {}).textContent || '{}'); } catch (e) { cfg = {}; }

  var DICHT_KEY = 'tfc-winactie-dicht';
  var INGESCHREVEN_KEY = 'tfc-winactie-ingeschreven';
  var DAG = 864e5;

  function lees(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function schrijf(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* opslag geblokkeerd */ } }

  /* ---------- Klaviyo-helpers ---------- */
  function kl(method, args) {
    var k = window.klaviyo;
    if (k && typeof k[method] === 'function') return Promise.resolve(k[method].apply(k, args));
    (window._learnq = window._learnq || []).push([method].concat(args));
    return Promise.resolve();
  }
  function isBekend() {
    var k = window.klaviyo;
    if (k && typeof k.isIdentified === 'function') {
      return Promise.resolve(k.isIdentified()).catch(function () { return false; });
    }
    return Promise.resolve(false);
  }
  function absoluut(url) {
    if (!url) return null;
    if (url.indexOf('//') === 0) return 'https:' + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }

  /* ---------- Added to Cart ---------- */
  function trackToegevoegd(cart, variantId, aantal) {
    if (!cart || !cart.items) return;
    var item = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].variant_id) === String(variantId)) { item = cart.items[i]; break; }
    }
    if (!item) return;
    var props = {
      $value: cart.total_price / 100,
      Currency: cart.currency || cfg.currency,
      AddedItemProductName: item.product_title,
      AddedItemProductID: item.product_id,
      AddedItemVariantID: item.variant_id,
      AddedItemVariantName: item.variant_title,
      AddedItemSKU: item.sku,
      AddedItemCategories: item.product_type ? [item.product_type] : [],
      AddedItemBrand: item.vendor,
      AddedItemImageURL: absoluut(item.image),
      AddedItemURL: absoluut(item.url),
      AddedItemPrice: item.final_price / 100,
      AddedItemQuantity: aantal || 1,
      ItemNames: cart.items.map(function (x) { return x.product_title; }),
      ItemCount: cart.item_count,
      CheckoutURL: absoluut(cfg.cartUrl || '/cart'),
      Items: cart.items.map(function (x) {
        return {
          ProductID: x.product_id,
          VariantID: x.variant_id,
          SKU: x.sku,
          ProductName: x.product_title,
          VariantName: x.variant_title,
          Quantity: x.quantity,
          ItemPrice: x.final_price / 100,
          RowTotal: x.final_line_price / 100,
          ProductURL: absoluut(x.url),
          ImageURL: absoluut(x.image),
          Brand: x.vendor
        };
      })
    };
    // Alleen identificeren als de bezoeker al bekend is (ingelogde klant); verder doet Klaviyo de koppeling zelf.
    isBekend().then(function (bekend) {
      if (!bekend && cfg.email) return kl('identify', [{ email: cfg.email }]);
    }).then(function () {
      return kl('track', ['Added to Cart', props]);
    }).catch(function () { /* tracking mag de winkel nooit hinderen */ });
  }

  /* Elk verzoek naar /cart/add volgen (koopknop, upsell-venster, snel toevoegen). Het thema-event
     on:cart:add komt niet altijd (01-10: met het upsell-venster bleef het uit), dus niet daarop leunen. */
  var CART_ADD = /\/cart\/add(\.js)?(\?|$)/;
  var origFetch = window.fetch;
  function uitBody(body) {
    try {
      if (window.FormData && body instanceof FormData) return [{ id: body.get('id'), q: Number(body.get('quantity')) || 1 }];
      if (typeof body === 'string') {
        if (body.trim().charAt(0) === '{') {
          var j = JSON.parse(body);
          return (j.items || [j]).map(function (x) { return { id: x.id, q: Number(x.quantity) || 1 }; });
        }
        var p = new URLSearchParams(body);
        return [{ id: p.get('id'), q: Number(p.get('quantity')) || 1 }];
      }
    } catch (e) { /* onbekend formaat */ }
    return [];
  }
  function naToevoegen(body) {
    var regels = uitBody(body).filter(function (r) { return r.id; });
    if (!regels.length || !origFetch) return;
    origFetch.call(window, (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { regels.forEach(function (r) { trackToegevoegd(cart, r.id, r.q); }); })
      .catch(function () { /* tracking mag de winkel nooit hinderen */ });
  }
  if (origFetch) {
    window.fetch = function (input, init) {
      var res = origFetch.apply(this, arguments);
      try {
        var url = String(input && input.url || input);
        var methode = String(init && init.method || input && input.method || 'GET').toUpperCase();
        if (methode === 'POST' && CART_ADD.test(url.split('#')[0])) {
          var body = init && init.body;
          res.then(function (r) { if (r && r.ok) naToevoegen(body); }).catch(function () {});
        }
      } catch (e) { /* nooit hinderen */ }
      return res;
    };
  }
  if (window.XMLHttpRequest) {
    var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { try { this.__tfcAdd = String(m).toUpperCase() === 'POST' && CART_ADD.test(String(u)); } catch (e) {} return xOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      if (this.__tfcAdd) { var x = this; x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) naToevoegen(body); }); }
      return xSend.apply(this, arguments);
    };
  }

  /* ---------- Inschrijven (Klaviyo client subscriptions) ---------- */
  function abonneer(email, bron, metEigenschappen) {
    var profiel = {
      email: email,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    if (metEigenschappen) profiel.properties = { bron: bron, winactie: true, taal: cfg.locale || null };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: bron,
            profile: { data: { type: 'profile', attributes: profiel } }
          },
          relationships: { list: { data: { type: 'list', id: cfg.list } } }
        }
      })
    });
  }

  function geldigEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  function koppelFormulier(form) {
    if (form.dataset.tfcGekoppeld) return;
    form.dataset.tfcGekoppeld = '1';
    var email = form.querySelector('input[type="email"]');
    var consent = form.querySelector('input[type="checkbox"]');
    var fout = form.querySelector('.js-tfc-winactie-error');
    var gelukt = form.querySelector('.js-tfc-winactie-success');
    var knoppen = form.querySelectorAll('button[type="submit"]');

    function toonFout(tekst, veld) {
      fout.textContent = tekst;
      fout.hidden = !tekst;
      [email, consent].forEach(function (el) { el.removeAttribute('aria-invalid'); });
      if (veld) { veld.setAttribute('aria-invalid', 'true'); veld.focus(); }
    }

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      var waarde = (email.value || '').trim();
      if (!geldigEmail(waarde)) return toonFout(form.dataset.msgEmail, email);
      if (!consent.checked) return toonFout(form.dataset.msgConsent, consent);
      toonFout('');
      if (!cfg.company || !cfg.list) return toonFout(form.dataset.msgGeneral);
      knoppen.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); b.classList.add('is-loading'); });
      var bron = form.dataset.bron || 'winactie-popup';
      abonneer(waarde, bron, true).then(function (r) {
        // Weigert Klaviyo de extra eigenschappen, dan alsnog inschrijven en de bron via identify meegeven.
        if (r.status === 400) return abonneer(waarde, bron, false).then(function (r2) { r2.tfcZonderEigenschappen = true; return r2; });
        return r;
      }).then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        schrijf(INGESCHREVEN_KEY, String(Date.now()));
        var extra = { email: waarde };
        if (r.tfcZonderEigenschappen) { extra.bron = bron; extra.winactie = true; }
        kl('identify', [extra]).catch(function () {});
        Array.prototype.forEach.call(form.children, function (el) { if (el !== gelukt) el.hidden = true; });
        gelukt.hidden = false;
        gelukt.focus();
      }).catch(function () {
        toonFout(form.dataset.msgGeneral);
      }).then(function () {
        knoppen.forEach(function (b) { b.removeAttribute('aria-disabled'); b.classList.remove('is-loading'); });
      });
    });
  }

  function koppelAlles() {
    document.querySelectorAll('.js-tfc-winactie-form').forEach(koppelFormulier);
  }

  /* ---------- Popup ---------- */
  function popup() {
    var el = document.getElementById('tfc-winactie-popup');
    if (!el) return;
    var forceer = /[?&]tfc_winactie=1\b/.test(window.location.search);
    if (!forceer) {
      if (lees(INGESCHREVEN_KEY)) return;
      var dicht = Number(lees(DICHT_KEY) || 0);
      if (dicht && Date.now() - dicht < 30 * DAG) return;
    }
    var win = el.querySelector('[role="dialog"]');
    // Afbeelding pas laden voor bezoekers die de popup echt te zien krijgen.
    var foto = el.querySelector('.tfc-winactie-popup__img');
    if (foto) foto.loading = 'eager';
    var vorige = null, geopend = false, klaar = false;

    function focusbaar() {
      return Array.prototype.filter.call(
        win.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])'),
        function (x) { return x.offsetParent !== null && !x.closest('[hidden]'); }
      );
    }
    function toets(evt) {
      if (evt.key === 'Escape') { evt.preventDefault(); sluit(); return; }
      if (evt.key !== 'Tab') return;
      var f = focusbaar(); if (!f.length) return;
      var eerste = f[0], laatste = f[f.length - 1];
      if (evt.shiftKey && (document.activeElement === eerste || document.activeElement === win)) { evt.preventDefault(); laatste.focus(); }
      else if (!evt.shiftKey && document.activeElement === laatste) { evt.preventDefault(); eerste.focus(); }
    }
    function open() {
      if (geopend || klaar) return;
      if (document.querySelector('.modal[open]:not(#tfc-winactie-popup), cart-drawer[open], .drawer[open], age-verification-pop-up[open]')) {
        window.setTimeout(open, 10000);
        return;
      }
      geopend = true; klaar = true;
      vorige = document.activeElement;
      el.setAttribute('open', '');
      document.addEventListener('keydown', toets);
      var input = win.querySelector('input[type="email"]');
      window.setTimeout(function () { (input || win).focus(); }, 150);
    }
    function sluit() {
      if (!geopend) return;
      geopend = false;
      el.removeAttribute('open');
      document.removeEventListener('keydown', toets);
      if (!lees(INGESCHREVEN_KEY)) schrijf(DICHT_KEY, String(Date.now()));
      if (vorige && typeof vorige.focus === 'function') vorige.focus();
    }
    el.addEventListener('click', function (evt) {
      if (evt.target === el || (evt.target.closest && evt.target.closest('.js-tfc-winactie-close'))) sluit();
    });

    window.setTimeout(open, forceer ? 500 : 15000);
    // Exit-intent alleen op desktop (muis), en pas na een paar seconden op de pagina.
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      window.setTimeout(function () {
        document.addEventListener('mouseout', function wegg(evt) {
          if (!evt.relatedTarget && evt.clientY <= 0) { document.removeEventListener('mouseout', wegg); open(); }
        });
      }, 4000);
    }
  }

  function start() { koppelAlles(); popup(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
